
export default {
  inheritAttrs: false,
  props: {
    except: {
      type: [String, Array],
      default: () => []
    },
    only: {
      type: [String, Array],
      default: () => []
    },
    mode: {
      type: [String, Object],
      default: 'vertical'
    },
    details: {
      type: Object,
      default: null
    },
    icons: {
      type: [Boolean, String],
      default: false
    },
    gap: {
      type: [String, Object],
      default: 'sm'
    }
  },
  computed: {
    data() {
      return this.details || this.$contact.details
    },
    direction() {
      // TODO: Do not return hash in vessel
      return this.$vessel.coerce(this.mode, value => {
        return value == 'vertical' ? 'col' : { all: 'col', lg: 'row' }
      })
    }
  },
  methods: {
    showItem(item) {
      const only = Array.isArray(this.only) ? this.only : [this.only]
      const except = Array.isArray(this.except) ? this.except : [this.except]

      if (only.length) {
        return only.includes(item) && this.data[item]
      } else {
        return !except.includes(item) && this.data[item]
      }
    }
  }
}
